import {DefaultComponent, ViewportModule} from "libs";


class AubadeComponent extends DefaultComponent{
    constructor(element, bootstrap) {
        super(element, bootstrap);
    }

    get viewport(){
        return this.bootstrap.get(ViewportModule).viewport;
    }

    get router(){
        return this.bootstrap.router;
    }
}

export {AubadeComponent}